import React from 'react';
import classnames from 'classnames';
import moment from 'moment';
import { makeInitials } from '../../helpers/util';
import Avatar from 'material-ui/Avatar';
import * as styles from './PostPlatformPreview.scss';

function GMBPreview(props) {
  var account = props.account,
      images = props.images,
      link = props.link,
      message = props.message,
      postDate = props.postDate,
      postType = props.postType,
      videos = props.videos;
  var hasVideo = !!(videos !== null && videos !== void 0 && videos[0]);
  var accountInfo = {
    imageUrl: (account === null || account === void 0 ? void 0 : account.avatarImageUrl) || false,
    username: (account === null || account === void 0 ? void 0 : account.username) || 'My business'
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("section", {
    className: classnames(styles.gmbWrap, hasVideo && styles.gmbUnsupported)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.gmbHeader
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: accountInfo.imageUrl,
    style: accountInfo.imageUrl ? {
      backgroundColor: 'white'
    } : {}
  }, !accountInfo.imageUrl ? makeInitials("".concat(accountInfo.username)) : null), /*#__PURE__*/React.createElement("div", {
    className: styles.gmbName
  }, /*#__PURE__*/React.createElement("strong", null, accountInfo.username), /*#__PURE__*/React.createElement("time", null, postDate ? moment(postDate).format('M/D/YYYY, h:mm a') : moment().format('M/D/YYYY, h:mm a')))), /*#__PURE__*/React.createElement("div", {
    className: styles.gmbContentWrap
  }, !!images && images.length > 0 && postType === 'imagePost' && /*#__PURE__*/React.createElement("img", {
    className: styles.gmbMedia,
    src: images[0]
  }), /*#__PURE__*/React.createElement("article", {
    className: styles.gmbContent,
    id: "test-gmb-message"
  }, message && message.length > 0 ? message : 'Type a message to see the preview here.'), postType === 'linkPost' && !!link && /*#__PURE__*/React.createElement("div", {
    className: styles.gmbFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.gmbButton
  }, /*#__PURE__*/React.createElement("div", null, "Learn more"))))), hasVideo && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: '50%',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    id: "test-gmb-video"
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.gmbUnsupportedLabel
  }, "Video Posts are not supported on Google Business Profile.")));
}

export default GMBPreview;